module.exports = __webpack_public_path__ + "static/media/entremap-icon.328c2e97.png";